// import React, { useState, useEffect, useRef } from 'react'
// import './Etsyguestbook.css'
// import { S3CLOUD_CLOUDFRONT_ETSY } from '../../../config/s3directories';

// const steps = [
//   {
//     id: 1,
//     title: 'Sign Up',
//     description: 'Create an account to start creating and managing your guestbooks.',
//     image: '1_usersignup.png',
//   },
//   {
//     id: 2,
//     title: 'Log In',
//     description: 'Log in to your account to access your dashboard and guestbooks.',
//     image: '2_login.png',
//   },
//   {
//     id: 3,
//     title: 'Go to Dashboard',
//     description: 'From the home page, access the available tools and features.',
//     image: '3_home.png',
//   },
//   {
//     id: 4,
//     title: 'Create a Guestbook',
//     description: 'Open the app tools page and begin creating your guestbook.',
//     image: '4_apptoolspage.png',
//   },
//   {
//     id: 5,
//     title: 'Fill in Guestbook Details',
//     description: 'Enter the required information and customize your guestbook settings.',
//     image: '5_fillup.png',
//   },
//   {
//     id: 6,
//     title: 'Save and Continue',
//     description: 'Review your settings and proceed to the next step.',
//     image: '6_createcontinue.png',
//   },
//   {
//     id: 7,
//     title: 'Configure Guestbook Settings',
//     description: 'Set up your guestbook preferences and entry options.',
//     image: '7_guestbookstartsetting.png',
//   },
//   {
//     id: 8,
//     title: 'Customize Your Guestbook',
//     description: 'Edit the appearance and content of your guestbook.',
//     image: '8_guestbookedit.png',
//   },
//   {
//     id: 9,
//     title: 'Activate Your Guestbook',
//     description: 'Use the activation code to make your guestbook available to guests.',
//     image: '9_activatecode.png',
//   },
//   {
//     id: 10,
//     title: 'Guest Experience',
//     description: 'See how guests will view and interact with your guestbook.',
//     image: '10_guestview.png',
//   },
//   {
//     id: 11,
//     title: 'Grid View',
//     description: 'View guestbook entries in a responsive grid layout across web, tablet, and mobile devices.',
//     image: '11_webtabletmobile_grid_view.png',
//   },
//   {
//     id: 12,
//     title: 'Print Grid Layout',
//     description: 'Generate a printable version of the grid view.',
//     image: '12_gridprint.png',
//   },
//   {
//     id: 13,
//     title: 'Scatter View',
//     description: 'Display guestbook entries in a freeform scatter layout.',
//     image: '13_webtabletmobile_scatter_view.png',
//   },
//   {
//     id: 14,
//     title: 'Print Scatter Layout',
//     description: 'Generate a printable version of the scatter view.',
//     image: '14_scatterprint.png',
//   },
//   {
//     id: 15,
//     title: 'Download Transparent Images',
//     description: 'Download guestbook entries with transparent backgrounds for custom printing and design work.',
//     image: '15_downloadtransparent.png',
//   },
//   {
//     id: 16,
//     title: 'Lookup Guestbook',
//     description: 'Search for and access an existing guestbook using its code.',
//     image: '16_lookup.png',
//   },
//   {
//     id: 17,
//     title: 'Transparent Background Option',
//     description: 'Enable transparent backgrounds for downloaded guestbook entries.',
//     image: '17_transparent_button.png',
//   },
//   {
//     id: 18,
//     title: 'Slideshow Mode',
//     description: 'Present guestbook entries in an automated slideshow.',
//     image: '18_slideshow.png',
//   },
// ];

// function useInView(threshold = 0.15) {
//   const ref = useRef(null)
//   const [visible, setVisible] = useState(false)
//   useEffect(() => {
//     const el = ref.current
//     if (!el) return
//     const obs = new IntersectionObserver(
//       ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect() } },
//       { threshold }
//     )
//     obs.observe(el)
//     return () => obs.disconnect()
//   }, [threshold])
//   return [ref, visible]
// }

// function StepRow({ step }) {
//   const [ref, visible] = useInView()
//   return (
//     <div ref={ref} className={`eg-step ${visible ? 'eg-step--visible' : ''}`}>
//       <div className="eg-step__image-wrap">
//         <img src={S3CLOUD_CLOUDFRONT_ETSY+'listing1/' + step.image} alt={`Step ${step.id} illustration`} className="eg-step__image" loading="lazy" />
//       </div>
//       <div className="eg-step__content">
//         <span className="eg-step__number">Step {step.id}</span>
//         <h2 className="eg-step__title">{step.title}</h2>
//         <p className="eg-step__desc">{step.description}</p>
//       </div>
//     </div>
//   )
// }

// function Etsyguestbook() {
//   return (
//     <div className="Etsyguestbook_root">
//       <header className="eg-header">
//         <p className="eg-header__eyebrow">How it works</p>
//         <h1 className="eg-header__title">Getting Started</h1>
//         <p className="eg-header__sub">Follow these steps to set up your digital guestbook</p>
//       </header>
//       <div className="eg-steps">
//         {steps.map(step => <StepRow key={step.id} step={step} />)}
//       </div>
//     </div>
//   )
// }

// export default Etsyguestbook

import React, { useState, useEffect, useRef } from 'react';
import './Etsyguestbook.css';
import { S3CLOUD_CLOUDFRONT_ETSY } from '../../../config/s3directories';

const steps = [
  {
    id: 1,
    title: 'Sign Up',
    description: 'Select "Wedding" (you can change this later if needed), then create an account to start creating and managing your guestbooks.',
    image: '1_usersignup.png',
  },
  {
    id: 2,
    title: 'Log In',
    description: 'After verifying your email address, log in to your account to access your Weavebliss homepage (dashboard).',
    image: '2_login.png',
  },
  {
    id: 3,
    title: 'Go to Dashboard',
    description: 'From the homepage, access the available tools and features. At the top of the page, click "Guestbook" to be redirected to the guestbook creation page.',
    image: '3_home.png',
  },
  {
    id: 4,
    title: 'Create a Guestbook',
    description: 'Create your guestbook here.',
    image: '4_apptoolspage.png',
  },
  {
    id: 5,
    title: 'Fill in Guestbook Details',
    description: `
    Enter the required information and customize your guestbook settings.
    
    The URL handler is the link used to access your guestbook after the event.
    
    The passcode is required for guests to access the guestbook entry page, where they can draw doodles, write wishes, and upload photos.
    
    The moderator passcode (mod passcode) is required to access and manage the actual guestbook.
    `,
    image: '5_fillup.png',
  },
  {
    id: 6,
    title: 'Save and Continue',
    description: 'Review your settings and proceed to the next step.',
    image: '6_createcontinue.png',
  },
  {
    id: 7,
    title: 'Configure Guestbook Settings',
    description: 'Set your guestbook background color and font color. The background color will appear on both the guestbook entry page and the guestbook itself. The font color will be used for text displayed on both pages.',
    image: '7_guestbookstartsetting.png',
  },
  {
    id: 8,
    title: 'Customize Your Guestbook',
    description: 'Edit the content of your guestbook entry page. You can customize the text to match your event theme. The default message invites guests to draw flowers, but you can change it to any theme or message you prefer.',
    image: '8_guestbookedit.png',
  },
  {
    id: 9,
    title: 'Click to activate',
    description: 'Click on the shopping cart to open the popup and enter the activation code to activate the premium features.',
    image: '9_shopping_cart.png',
  },
  {
    id: 10,
    title: 'Activate Your Guestbook',
    description: 'Use the activation code to unlock all available features.',
    image: '9_activatecode.png',
  },
  {
    id: 11,
    title: 'Guest Experience',
    description: 'This is what your guests will see when accessing the guestbook from a web browser or mobile browser.',
    image: '10_guestview.png',
  },
  {
    id: 12,
    title: 'Grid View',
    description: 'After your event, your guestbook entries will be displayed in this grid layout. From here, you can edit and manage the settings of your guestbook page.',
    image: '11_webtabletmobile_grid_view.png',
  },
  {
    id: 13,
    title: 'Print Grid Layout',
    description: 'This is the printable grid-layout version of the doodles collected during your event. You can print it as wall art in A2 size and adjust the doodle size and overall scale to your preference.',
    image: '12_gridprint.png',
  },
  {
    id: 14,
    title: 'Scatter View',
    description: 'After your event, your guestbook entries can also be displayed in a scatter layout. From here, you can edit and manage the settings of your guestbook page.',
    image: '13_webtabletmobile_scatter_view.png',
  },
  {
    id: 15,
    title: 'Print Scatter Layout',
    description: 'This is the printable scatter-layout version of the doodles collected during your event. You can print it as wall art in A2 size and adjust the doodle size and overall scale to your preference.',
    image: '14_scatterprint.png',
  },
  {
    id: 16,
    title: 'Download Transparent Images',
    description: 'You can download your guestbook artwork in two versions: with a transparent background or with the selected background color applied.',
    image: '15_downloadtransparent.png',
  },
  {
    id: 17,
    title: 'Lookup Guestbook',
    description: 'This is where you can view your guestbook.',
    image: '16_lookup.png',
  },
  {
    id: 18,
    title: 'Transparent Button for Slideshow',
    description: 'Click the transparent button to toggle slideshow mode. This automatically displays guestbook entries and can be used as a presentation during your event.',
    image: '17_transparent_button.png',
  },
  {
    id: 19,
    title: 'Slideshow Mode',
    description: 'This is the slideshow mode of your guestbook.',
    image: '18_slideshow.png',
  },
];

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold }
    );

    obs.observe(el);

    return () => obs.disconnect();
  }, [threshold]);

  return [ref, visible];
}

function StepRow({ step, onImageClick }) {
  const [ref, visible] = useInView();

  const imageUrl =
    S3CLOUD_CLOUDFRONT_ETSY + 'listing1/' + step.image;

  return (
    <div
      ref={ref}
      className={`eg-step ${visible ? 'eg-step--visible' : ''}`}
    >
      <div className="eg-step__image-wrap">
        <img
          src={imageUrl}
          alt={`Step ${step.id} illustration`}
          className="eg-step__image"
          loading="lazy"
          onClick={() => onImageClick(imageUrl)}
        />
      </div>

      <div className="eg-step__content">
        <span className="eg-step__number">
          Step {step.id}
        </span>

        <h2 className="eg-step__title">
          {step.title}
        </h2>

        <p className="eg-step__desc">
          {step.description}
        </p>
      </div>
    </div>
  );
}

function Etsyguestbook() {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setSelectedImage(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () =>
      window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="Etsyguestbook_root">
      <header className="eg-header">
        <p className="eg-header__eyebrow">
          How it works
        </p>

        <h1 className="eg-header__title">
          Getting Started
        </h1>

        <p className="eg-header__sub">
          Follow these steps to set up your digital
          guestbook
        </p>
      </header>

      <div className="eg-steps">
        {steps.map((step) => (
          <StepRow
            key={step.id}
            step={step}
            onImageClick={setSelectedImage}
          />
        ))}
      </div>

      {selectedImage && (
        <div
          className="eg-lightbox"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Expanded preview"
            className="eg-lightbox__image"
            onClick={(e) => e.stopPropagation()}
          />

          <button
            className="eg-lightbox__close"
            onClick={() => setSelectedImage(null)}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}

export default Etsyguestbook;